<template lang="pug">
  .container.grid-lg
    .columns.my-2.align-end
      .column.col-mr-auto
        form(@submit.prevent="search")
          .form-group
            small Pesquisa
            .columns
              .column
                input.form-input.input-sm(type='text' v-model="descricao_cont")
              .column.col-auto
                button.btn.btn-link.tooltip.tooltip-bottom(type='submit', :data-tooltip="$i18n.t('views.buttons.filter.label')")
                  i.fa.fa-search.fa-lg
      .column.col-auto
        router-link(
          :to="{name: 'app.parametros.servicos.formularios.form', params: {id: 'new'}}"
          v-acl:allowed.admin.formularios.create
        )
          button.btn.btn-action.s-circle
            i.icon.icon-plus

    load-manager(:status="status")
      div
        table.table.table-striped.table-hover.table-sm
          thead
            tr
              th {{ $i18n.tModel('formulario.id')}}
              th {{ $i18n.tModel('formulario.descricao')}}
              th
          tbody
            tr(v-for="item in list" :key='item.id')
              td \#{{item.id}}
              td {{item.descricao}}
               td.text-right
                router-link(
                  :to="{name: 'app.parametros.servicos.formularios.form', params: {id: item.id}}"
                  v-acl:allowed.admin.formularios.update
                )
                  btn-icon.fa-lg(name='edit')
        .float-right
          paginator(:page='page', :pages='pages', @prev-page='prevPage', @next-page='nextPage' color='#599940')
</template>

<script>
import listMixin, { vuexDefaultMapping } from '@/mixins/list'

export default {
  mixins: [listMixin],
  vuex: { formularios: vuexDefaultMapping },

  computed: {
    descricao_cont: {
      get() {
        return this.query.descricao_cont
      },

      set(descricao_cont) {
        this.setQuery({ ...this.query, descricao_cont })
      },
    },
  },

  created() {
    if (!this.list || !this.list.length) {
      this.search()
    }
  },
}
</script>
